import moment from "moment";
import { useEffect, useState } from "react";
import { TfiTrash } from "react-icons/tfi";
import { BsExclamation } from "react-icons/bs";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { Col, Row } from "reactstrap";
import { ApplicantActions, googleCalendarActions } from "../../actions";
import { formatMoney } from "../../helpers";
import InterviewerForm from "../Application/InterviewerForm";
import RecuterForm from "../Application/RecuterFrom";
import StatusForm from "../Application/StatusForm";
import CardActionMenu from "../common/ActionMenu/CardActionMenu";
import VarticalDropdownMenuComponent from "../common/ActionMenu/VarticalDropDown";
import Form from "../common/Form/From";
import Loader from "../common/Loader/Loader";
import DownloadResume from "../DownloadResume/Downloadresume";
import Tabs from "../HistoryComponents/Tabs";
import styles from "./Detail.module.scss"
import useModal from "../Hooks/useModal";
import ModalDialog from "../common/Modal/Modal";
import CreateEventForm from "../Application/CreateEventForm";
import * as yup from "yup";
import ConfirmDialog from "../common/ConfirmDialog/ConfirmDialog";
import googleButton from "../../assets/images/btn_google_signin_dark_normal_web.png";
import googleButtonPressed from "../../assets/images/btn_google_signin_dark_pressed_web.png";
import { RiLogoutCircleRLine } from "react-icons/ri";
import { MdOutlineEvent, MdOutlineEventRepeat } from "react-icons/md";
import { applicantProfileService } from '../../services';
import ReferredProfileModal from '../../components/common/Modal/ReferredProfileModal';
import downArraow from '../../assets/images/down-arrow.svg'

const DetailComponent = (props) => {
    const searchParams = new URLSearchParams(document.location.search)
    const applicantData = useSelector((state) => state.applicant.boardApplicant)
    const allEvents = useSelector((state) => state.googleCalendar.allEvents?.data)
    const selectedEvent = useSelector((state) => state.googleCalendar.selectedEvent?.data)
    const user = useSelector((state) => state.authentication.user);
    const [loderPart, setLoderPart] = useState(false)
    const dispatch = useDispatch()
    const [gTokenAvailable, setGTokenAvailable] = useState(null);
    const [selRound, setSelRound] = useState('new');
    const [googleImage, setGoogleImage] = useState(googleButton);
    const [interviewDetailsLoading, setInterviewDetailsLoading] = useState(false);
    const [createEventLoading, setCreateEventLoading] = useState(false);
    const [suggestionList, setSuggestionList] = useState([]);
    const [initialValues, setInitialValues] = useState({
        summary: '',
        startTime: '',
        duration: '30',
        interviewers: [''],
        guestsCanSeeOtherGuests: false,
        location: 'office',
        visibility: 'public',
        description: '',
    });
    const {toggle: createEventToggle, visible: createEventVisible} = useModal();
    const { toggle: ConfirmToggle, visible: ConfirmModal } = useModal();
    const { toggle: referredProfileToggle, visible: referredProfileVisible } = useModal();


    const validationSchema = yup.object().shape({
        summary: yup.string().required("Event title is required"),
        startTime: yup.string().required("Event date & time is required"),
    })

    const capitalizeText = (text) => {
        return text?.charAt(0).toUpperCase() + text?.slice(1);
    }

    const handleInterviewSubmit = (values) => {
        if (applicantData?.id) {
            dispatch(ApplicantActions.updateApplicant(values, applicantData?.id));
        }
    };

    useEffect(() => {
        let gToken = localStorage.getItem('google-token');
        gToken ? setGTokenAvailable(true) : setGTokenAvailable(false);

        localStorage.removeItem('jobProfile');
        localStorage.removeItem('jobId');
        localStorage.removeItem('applicantId');
    }, []);
    
    useEffect(() => {
        applicantProfileService.getMentaionUsers("").then((res) => {
          setSuggestionList(res);
        });
      }, []);
    
    useEffect(() => {
        if (localStorage.getItem('google-token') && applicantData?.cid) {
            dispatch(googleCalendarActions.getAllEvent(applicantData?.cid));
        }
        setSelRound('new');
    }, [applicantData?.cid]);

    useEffect(() => {
        if (selRound !== 'new') {
            const eventId = allEvents?.find((ele) => ele.round === +selRound).eventId;

            setInterviewDetailsLoading(true);
            dispatch(googleCalendarActions.getEvent(eventId)).then((res) => {
                setInterviewDetailsLoading(false);
            });
        } else {
            setInitialValues({
                summary: '',
                startTime: '',
                duration: '30',
                interviewers: [''],
                guestsCanSeeOtherGuests: false,
                location: 'office',
                visibility: 'public',
                description: '',
            })
        }
    }, [selRound]);

    const handleGoogleLogin = () => {
        setGoogleImage(googleButtonPressed);
        
        localStorage.setItem('jobProfile', searchParams?.get('profileId'));
        localStorage.setItem('jobId', searchParams?.get('jobId'));
        localStorage.setItem('applicantId', applicantData?.id);

        dispatch(googleCalendarActions.login());
    }

    const handleGoogleLogout = () => {
        localStorage.removeItem('google-token')
        setGTokenAvailable(false);

        dispatch(googleCalendarActions.logout());
    }

    const renderCreateEventForm = (errors, touched)  => {
        return (
            <CreateEventForm
              errors={errors}
              touched={touched}
              selRound={selRound}
              isLoading={createEventLoading}
            />
        )
    }

    const handleRescheduleInterview = () => {
        let attendees = [];
        let interviewerIds = [];

        selectedEvent?.attendees.forEach((ele) => {
            if (ele.email !== applicantData.email) {
                attendees.push(ele.email);
            }
        });

        attendees.forEach((ele) => {
            suggestionList?.forEach((item) => {
                if (item.email.toLowerCase() === ele) {
                    interviewerIds.push(item.id)
                }
            })
        })

        let editInitialValues = {
            summary: selectedEvent?.summary,
            startTime: selectedEvent?.start.dateTime.split('+')[0],
            duration: moment(selectedEvent?.end.dateTime).diff(moment(selectedEvent?.start.dateTime), 'minutes'),
            interviewers: interviewerIds.length ? interviewerIds : [''],
            guestsCanSeeOtherGuests: selectedEvent?.guestsCanSeeOtherGuests,
            location: selectedEvent?.location,
            visibility: selectedEvent?.visibility,
            description: selectedEvent?.description ?? '',
        }

        setInitialValues(editInitialValues);
        createEventToggle();
    }

    const handleSubmit = (formEventData) => {
        setCreateEventLoading(true);

        let interviewerEmails = [];

        formEventData.interviewers.forEach((ele) => {
            suggestionList?.forEach((item) => {
                if (item.id === ele) {
                    interviewerEmails.push(item.email)
                }
            })
        })

        let cid = applicantData.cid;

        formEventData.attendees = [...interviewerEmails, applicantData.email];

        if (selRound === 'new') {
            let round = allEvents.length ? allEvents?.at(-1).round + 1 : 1;
            const eventData = {...formEventData, cid, round};

            dispatch(googleCalendarActions.createEvent(eventData)).then((res) => {
                setCreateEventLoading(false);
                createEventToggle();
                handleInterviewSubmit({interviewerID: formEventData?.interviewers});
                dispatch(googleCalendarActions.getAllEvent(applicantData?.cid)).then((res) => {
                    setSelRound(round);
                })
            });
        } else {
            const eventData = {...formEventData, cid, round: selRound};

            dispatch(googleCalendarActions.updateEvent(selectedEvent?.id, eventData)).then((res) => {
                setCreateEventLoading(false);
                createEventToggle();
                handleInterviewSubmit({interviewerID: formEventData?.interviewers});
            })
        }

    }

    const handleCancelEvent = () => {
        dispatch(googleCalendarActions.deleteEvent(selectedEvent?.id))
        .then((res) => {
            dispatch(googleCalendarActions.getAllEvent(applicantData?.cid));
            setSelRound('new')
        })
    }

    return (
        applicantData ?
            <div className={styles.detailsMain}>

                <Row className={styles.mainRow}>
                    <div className={styles.detHeaderPart}>
                        <div className={(user && user.userRole !== 4 ? '' : 'w-100 ') + styles.headPart}>
                            <span className={styles.nmPart}>{applicantData?.name ? applicantData?.name : ""}</span>
                            <div className={styles.actionPart}>
                                <div className={user && user.userRole !== 4 ? '' : 'visually-hidden'}>
                                    <VarticalDropdownMenuComponent className="customDropdown" flag={true} row={applicantData} setDeleteId={props?.setDeleteId} setActiveData={props?.setActiveData} setEditedData={props?.setEditedData} referredProfileToggle={referredProfileToggle} />
                                </div>
                            </div>
                        </div>

                       { (user && user.userRole !== 4) && <div className={styles.headingPart}>
                            Details
                        </div>}
                    </div>
                    <Col md={(user && user.userRole !== 4) ? 7 : 12} sm={(user && user.userRole !== 4) ? 6 : 12} className={((user && user.userRole !== 4) ? 'border-0 ' : '') + styles.detailPart}>
                        <Row className={styles.innerRow}>
                            { user && user.userRole !== 4 ?
                                <Col md={4} sm={3} className={styles.columnPart}>
                                <span>Education</span>
                                {applicantData?.education}
                            </Col> : ""
                            }
                            <Col md={4} sm={3} className={styles.columnPart}>
                                <span>Position Type</span>
                                {applicantData?.positionType}
                            </Col>
                            {applicantData?.experienceYear || applicantData?.experienceMonth ?
                                <Col md={4} sm={3} className={styles.columnPart}>
                                    <span>Experience</span>
                                    {applicantData?.experienceYear ? applicantData?.experienceYear + " Y " : ""}  {applicantData?.experienceMonth ? applicantData?.experienceMonth + " M" : ""}
                                </Col> : ""
                            }
                            {applicantData?.noticePeriod && user && user.userRole !== 4 ?
                                <Col md={4} sm={3} className={styles.columnPart}>
                                    <span>Notice Period </span>
                                    {applicantData?.noticePeriod}
                                </Col> : ""
                            }

                            {applicantData?.currentCTC && user && user.userRole !== 4 ?
                                <Col md={4} sm={3} className={styles.columnPart}>
                                    <span>Current CTC </span>
                                    {formatMoney(applicantData?.currentCTC)}
                                </Col> : ""
                            }

                            {applicantData?.expectedCTC && user && user.userRole !== 4 ?
                                <Col md={4} sm={3} className={styles.columnPart}>
                                    <span>Expected CTC </span>
                                    {formatMoney(applicantData?.expectedCTC)}
                                </Col> : ""
                            }

                            <Col md={4} sm={3} className={styles.columnPart}>
                                <span>Resume </span>
                                <DownloadResume resume={applicantData?.resume} />
                            </Col>
                            {applicantData?.phone ?
                                <Col md={4} sm={3} className={styles.columnPart}>
                                    <span>Mobile </span>
                                    <a href={`tel:${applicantData?.phone}`} style={{ textDecoration: 'none' }}>{applicantData?.phone}</a>                                                                      
                                </Col> : ""
                            }
                            {applicantData?.email ?
                                <Col md={4} sm={3} className={styles.columnPart}>
                                    <span>Email </span>
                                    <a href={`mailto:${applicantData?.email}`} style={{ textDecoration: 'none' }}>{applicantData?.email}</a>
                                </Col> : ""
                            }
                            {applicantData?.location && user && user.userRole !== 4 ?
                                <Col md={4} sm={3} className={styles.columnPart}>
                                    <span>Preferred Location</span>
                                    {applicantData?.location}
                                </Col> : ""
                            }
                            {applicantData?.currLocation && user && user.userRole !== 4 ?
                                <Col md={4} sm={3} className={styles.columnPart}>
                                    <span>Current Location</span>
                                    {applicantData?.currLocation}
                                </Col> : ""
                            }
                            <Col md={4} sm={3} className={styles.columnPart}>
                                <span>Source</span>
                                {applicantData?.source === 0 ? "Internal" :applicantData?.source === 1 ? "External" :applicantData?.source === 2 ? "Careers": "Referral" }
                            </Col>
                            {user && user.userRole <= 3 && applicantData?.referral?.name &&
                                <Col md={4} sm={3} className={styles.columnPart}>
                                    <span>Referred by</span>
                                    {applicantData?.referral?.name}{" "}{'('+applicantData?.referral?.email+')'}
                                </Col>
                            }
                            {applicantData?.createdAt ?
                                <Col md={4} sm={3} className={styles.columnPart}>
                                    <span>Created At</span>
                                        {moment(applicantData?.createdAt).format("DD MMM YYYY")} at {moment(applicantData?.createdAt).format("h:mm a")}
                                </Col> : ""}
                            {applicantData?.updatedAt ?
                                <Col md={4} sm={3} className={styles.columnPart}>
                                    <span>Updated At</span>
                                    {moment(applicantData?.updatedAt).format("DD MMM YYYY")} at {moment(applicantData?.updatedAt).format("h:mm a")}
                                </Col> : ""}


                        </Row>
                    </Col>

                    {
                        (user && user.userRole !== 4) && 
                        <Col md={5} sm={6} className={styles.editPart}>
                            <div className="statusForm">
                                <StatusForm
                                    row={applicantData}
                                    getBoardData={props?.getBoardData}
                                />
                            </div>

                            <div className="recuter-Part">
                                <RecuterForm row={applicantData} getBoardData={props?.getBoardData} />
                            </div>
                            <div className={styles.eventBtnsContainer}>
                                {
                                    !gTokenAvailable &&
                                    <div className="w-100 d-flex justify-content-end">
                                        <img onClick={handleGoogleLogin} src={googleImage} alt="Sign in with Google" />
                                    </div>
                                }
                                {
                                    gTokenAvailable &&
                                    <>
                                        <div className={styles.roundContainer}>
                                            <label className={styles.roundLabel} htmlFor="round">Interview Round</label>
                                            <select onChange={(e) => setSelRound(e.target.value)} name="round" id="round" style={{minWidth:"150px"}}>
                                                {allEvents?.map((event) => (
                                                    <option selected={selRound !== 'new' && selRound === event.round} value={event.round}>{event.round}</option>
                                                ))}
                                                <option selected={selRound === 'new'} value="new">New</option>
                                            </select>
                                            <img className="down-arrow-image" src={downArraow} alt="downArrow" />
                                        </div>
                                        <div className={styles.scheduleBtnContainer}>
                                            {
                                                selRound === 'new' ?
                                                    <MdOutlineEvent color="#5382ba" onClick={() => createEventToggle()} size={34} title="Schedule Interview" /> : moment(selectedEvent?.end.dateTime).isSameOrAfter(moment()) &&
                                                    <MdOutlineEventRepeat color="#5382ba" size={34} onClick={handleRescheduleInterview} title="Reschedule Interview" />
                                            }
                                            <RiLogoutCircleRLine color="red" size={34} onClick={handleGoogleLogout} className="ms-3" title="Google Logout" />
                                        </div>
                                    </>
                                }
                            </div>
                            {
                                gTokenAvailable && selRound !== 'new' &&
                                <div className={`${styles.interviewDetailsContainer} my-3 p-2 pb-0`}>
                                    {
                                        !interviewDetailsLoading ?
                                            <>
                                                <div className="d-flex justify-content-between align-items-center mb-2">
                                                    <h5 className="m-0">Interview Details</h5>
                                                    {
                                                        moment(selectedEvent?.end.dateTime).isSameOrAfter(moment()) &&
                                                        <TfiTrash title="Cancel Interview" onClick={() => ConfirmToggle()} />
                                                    }
                                                </div>
                                                <ul>
                                                    <li>Date & Time: <span>{moment(selectedEvent?.start.dateTime).format('DD MMMM YYYY, LT')}</span></li>
                                                    <li>Duration: <span>{`${moment(selectedEvent?.end.dateTime).diff(moment(selectedEvent?.start.dateTime), 'minutes')} mins`}</span></li>
                                                    <li>Interviewer: {
                                                        selectedEvent?.attendees.map((ele) => (
                                                            ele.email.includes('gloify.com') && <span>{ele.email}&nbsp;</span>
                                                        ))
                                                    }
                                                    </li>
                                                    <li>Location: <span>{capitalizeText(selectedEvent?.location)}</span></li>
                                                </ul>
                                            </> :
                                            <>
                                                <Loader width={30} height={30} color={"#5382ba"} />
                                                <p className="text-center pb-2 m-0">Interview Details Loading...</p>
                                            </>
                                    }
                                </div>
                            }
                        </Col>

                    }
                    
                </Row>
                <Row>
                    <Col md={12} sm={12}>
                        <div className={styles.commentPart}>
                            <div className={styles.commentTitle}>Activity</div>
                            <Tabs selectedId={applicantData?.id} />
                        </div>
                    </Col>
                </Row>

                <ModalDialog toggle={createEventToggle} visible={createEventVisible} title={selRound === 'new' ? 'Create Event' : 'Update Event'} size="lg" >
                    <Form renderForm={renderCreateEventForm}
                        handleSubmit={handleSubmit}
                        initialValues={initialValues}
                        validationSchema={validationSchema} />
                </ModalDialog>

                <ConfirmDialog
                    visible={ConfirmModal}
                    toggle={ConfirmToggle}
                    title="Are you sure you want to cancel the interview?"
                    activeBtnClick={handleCancelEvent}
                >
                    <div className={`confirmIcon rounded-circle`}>
                        <BsExclamation style={{ fontSize: 42 }} />
                    </div>
                </ConfirmDialog>

                <ReferredProfileModal
                    toggle={referredProfileToggle}
                    visible={referredProfileVisible}
                    size='md'
                    bodyClass='p-0'
                    cloneCandidateId={applicantData?.cid}
                ></ReferredProfileModal>

            </div> : <Loader color={"#5382ba"} />
    )
}

export default DetailComponent;